import React from "react"
import ButtonMaterial from "@material-ui/core/Button"

const Button = (props) => <ButtonMaterial {...props} />

export { Button }
export default Button
